export default __webpack_public_path__ + "static/media/inc42.833d9801.svg";